import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { CalendarioHito } from './calendario-hitos.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarioHitosService {
  private hitosURL: string = urlJoin(environment.apiURL, 'hitos');

  constructor(
    private http: HttpClient,
    private notificationsService: NotificationsService
  ) { }

  getHitos(idUsuario?: string): Observable<CalendarioHito[]> {
    let params = new HttpParams();
    if (idUsuario) {
      params = params.set('id_usuario', idUsuario);
    }
    return this.http.get<CalendarioHito[]>(this.hitosURL, { params })
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }
}
